import { useAppSelector } from 'hooks/redux';
import { List } from 'immutable';
import React from 'react';

import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { useField } from 'app-components/flux/categories/categoryFormHooks';
import type { taxLineItemsTypes } from 'app-components/flux/tax-line-items';
import { taxLineItemsSelectors } from 'app-components/flux/tax-line-items';

import useStyles from './styles';

const TaxLineItemPersonal = () => {
  const { classes } = useStyles();

  const { value: taxForm } = useField('taxForm');
  const { value: taxLineItem, onChange, error, helperText } = useField('txfId');
  const taxLineItemsByTaxFormId = useAppSelector(taxLineItemsSelectors.getTaxLineItemsByTaxFormId);
  const taxLineItems: List<taxLineItemsTypes.TaxLineItem> = (taxForm && taxLineItemsByTaxFormId.get(taxForm)) || List();

  const taxDescription =
    (taxLineItems && taxLineItem && taxLineItems.find((item) => item.get('id') === taxLineItem)?.description) ||
    'Select a tax line to see a description';

  return (
    <>
      {taxForm ? (
        <TextField
          variant='filled'
          label='Tax line item'
          name='txfId'
          value={taxLineItem || ''}
          className={classes.dropDown}
          select
          onChange={onChange}
          id='tax-line-item-dropdown'
          error={error}
          helperText={helperText}
          InputLabelProps={{
            classes: {
              root: classes.inputLabel,
            },
          }}
        >
          {taxLineItems &&
            taxLineItems.map((form: taxLineItemsTypes.TaxLineItem) => (
              <MenuItem value={form.id} key={form.id}>
                <Tooltip title={form.description} placement='right'>
                  <span>{form.name}</span>
                </Tooltip>
              </MenuItem>
            ))}
        </TextField>
      ) : (
        <></>
      )}

      {taxForm && taxLineItem && (
        <Stack spacing={0.5}>
          <Typography variant='paragraphRegular'>Description</Typography>
          <Typography
            variant='bodyRegular'
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {taxDescription}
          </Typography>
        </Stack>
      )}
    </>
  );
};

export default TaxLineItemPersonal;
